import React, { Component } from 'react';
import getEvent from '../api/get-event';
import { Redirect, Link } from 'react-router-dom';
import Pixel, {PIXEL_ACTIONS} from '../components/utils/Pixel';
import WithFooter from '../layout/WithFooter';

class EventPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: null,
            notFound: false,
        };
    }

    componentDidMount() {
        getEvent(this.props.match.params.eventId)
        .then(response => {
            if (!response.ok) {
                this.setState({
                    notFound: true
                });
            }
            return response.json();
        }).then(result => {
            this.setState({
                event: result
            });
        });
    }

    render() {
        if (this.state.notFound) {
            return <Redirect to={`/not-found`} />
        }

        if (!this.state.event) {
            return <span>Loading...</span>
        }

        return (
            <WithFooter>
                <section>
                    <Pixel eventId={this.props.match.params.eventId} action={PIXEL_ACTIONS.OPEN} />
                    <div className="event-description">
                        <h4>{this.state.event.name}</h4>
                        <div className="description" dangerouslySetInnerHTML={{__html: this.state.event.description}} />
                    </div>
                </section>

                <table className="u-full-width performances-table">
                    <tbody>
                        { this.state.event.performances.map(performance => {
                            const performanceAddress = `/event/${this.props.match.params.eventId}/performance/${performance.uuid}`;
                            return <tr key={performance.uuid}><td><Link to={performanceAddress}>{performance.name}</Link></td></tr>
                        })}
                    </tbody>
                </table>
            </WithFooter>
        )
    }
};

export default EventPage;
